module.exports = __webpack_public_path__ + "img/ssyx_35.0305f3dd.jpg";